import React from 'react';
import Pagination from 'react-js-pagination';
import Li from '../Li/Li';
import Filters from '../Filters';
import AddNewLi from '../Li/AddNewLi';

const RoomsPageComponent = props => (
	<div>
		<Filters
			searchOnChange={props.searchOnChange}
			searchable={[props.rooms]}
      		multiSelectBoxes={[
				{
					label: 'Room Type',
					filterClass: 'roomTypeGroup',
					items: props.roomTypes,
					onChange: props.handleRoomTypeFilter,
				},
			]}
			Dropdowns={[
				{
					label: 'Location/Building',
					filterClass: 'buildingSelect',
					items: props.buildings,
					onChange: props.handleBuildingFilter,
					defaultValue: props.buildingFilter,
				},
				{
					label: 'Floor',
					filterClass: 'floorSelect',
					items: props.floors,
					onChange: props.handleFloorFilter,
					defaultValue: props.floorFilter,
				},
				{
					label: 'Room',
					filterClass: 'roomSelect',
					items: props.rooms,
					onChange: props.handleRoomFilter,
					defaultValue: props.roomFilter,
				},
			]}
			RoomDisplayToggle={[
				{
					onChange: props.handleShowInactiveRoomsFilter,
					label: 'Show Inactive',
					defaultValue: false,
				},
			]}
		/>


		<div className="rightSideContent">
			<AddNewLi mainDesc="Add New Room" RouteKey="rooms" />
			<Li
				onClick={props.scheduleFetch}
				showDelete={true}
				LiList={
					{
						linkKey: 'rooms',
						liClass: 'liListClass',
						items: props.filteredData.length ? props.filteredData.slice((props.activePage - 1) * 10, props.activePage * 10) : props.filteredData,
						deleteClick: props.deleteClick,
					}
				}
			/>
			<div className="paginationWrapper">
				{props.filteredData.length <= 10 ? '' : <Pagination
					hideDisabled
					prevPageText="prev"
					nextPageText="next"
					firstPageText="first"
					lastPageText="last"
					activePage={props.activePage}
					itemsCountPerPage={10}
					totalItemsCount={props.filteredData.length}
					onChange={props.handlePageChange}
				/>}
			</div>
		</div>
	</div>
);






export default RoomsPageComponent;



// WEBPACK FOOTER //
// ./src/Components/Pages/RoomsPageComponent.js